module.exports = __webpack_public_path__ + "static/img/shuban.badf947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/tijianbaogao/shuban.jpg
// module id = Y96e
// module chunks = 9